/**
 * Machine ID Attestation State
 * 
 * Tracks the status of machine ID attestation
 */

import { makeStateStore } from '@playcastdotio/StateStore';
import type { Serializable } from '@playcastdotio/CoreTypes';

export type AttestationStatus = 
  | 'idle'           // Not yet attempted
  | 'checking'       // Checking if attestation is needed
  | 'attesting'      // Currently attesting
  | 'attested'       // Successfully attested
  | 'failed'         // Attestation failed
  | 'not_needed';    // Already attested and valid

export type MachineIdAttestationState = {
  status: AttestationStatus;
  lastAttestedAt?: number;
  lastAttestedUserId?: string;
  expiresAt?: number;
  error?: string;
} & Record<string, Serializable>;

const initialState: MachineIdAttestationState = {
  status: 'idle',
};

export const machineIdAttestationState = makeStateStore<MachineIdAttestationState>(
  initialState,
  {
    replicate: { channel: 'machineIdAttestationState', targets: ['hostBackend'] },
  },
);

